module.exports = __webpack_public_path__ + "img/2.1eced24c.png";